import React, { Component } from 'react';
import { Row, Col, Input, Button, Alert, Container, Label, Card, CardBody } from "reactstrap";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

// actions
import { checkLogin, apiError } from '../../store/actions';

// import images
import logodark from "../../assets/images/my-logo.png";
import logolight from "../../assets/images/my-logo.png";
import withRouter from '../../components/Common/withRouter';

// Validation schema
const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required')
});

class Login extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.apiError("");
    document.body.classList.add("auth-body-bg");
  }

  componentWillUnmount() {
    document.body.classList.remove("auth-body-bg");
  }

  render() {
    return <LoginForm {...this.props} />;
  }
}

function LoginForm(props) {
  const initialValues = {
    username: '',
    password: ''
  };

  const handleSubmit = (values, { setSubmitting }) => {
    props.checkLogin(values, props.router.navigate);
    setSubmitting(false);
  };

  return (
    <React.Fragment>
      <div>
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
          <Row className="w-100 justify-content-center">
            <Col md={8} lg={6} xl={6}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center">
                    <Link to="/" className="">
                      <img src={logodark} alt="" width="75" className="auth-logo logo-dark mx-auto" />
                      <img src={logolight} alt="" width="75" className="auth-logo logo-light mx-auto" />
                    </Link>
                    <h4 className="font-size-18 mt-4">Welcome Back!</h4>
                    <p className="text-muted">Sign in to continue to Namaste World Tour.</p>
                  </div>
                  {props.loginError && <Alert color="danger">{props.loginError}</Alert>}
                  <div className="p-2 mt-4">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={LoginSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ errors, touched, isSubmitting }) => (
                        <Form className="form-horizontal">
                          <div className="auth-form-group-custom mb-4">
                            <i className="ri-user-2-line auti-custom-input-icon"></i>
                            <Label htmlFor="username">Email</Label>
                            <Field
                              name="username"
                              type="email"
                              className={`form-control ${errors.username && touched.username ? 'is-invalid' : ''}`}
                              id="username"
                              placeholder="Enter your email"
                            />
                            <ErrorMessage name="username" component="div" className="invalid-feedback" />
                          </div>

                          <div className="auth-form-group-custom mb-4">
                            <i className="ri-lock-2-line auti-custom-input-icon"></i>
                            <Label htmlFor="password">Password</Label>
                            <Field
                              name="password"
                              type="password"
                              className={`form-control ${errors.password && touched.password ? 'is-invalid' : ''}`}
                              id="password"
                              placeholder="Enter your password"
                            />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                          </div>

                          <div className="form-check">
                            <Input type="checkbox" className="form-check-input" id="customControlInline" />
                            <Label className="form-check-label" htmlFor="customControlInline">Remember me</Label>
                          </div>

                          <div className="mt-4 text-center">
                            <Button 
                              color="primary" 
                              className="w-md waves-effect waves-light" 
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? 'Logging in...' : 'Log In'}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>

                  <div className="mt-4 text-center">
                    <Link to="/forgot-password" className="text-muted">
                      <i className="mdi mdi-lock me-1"></i> Forgot your password?
                    </Link>
                  </div>

                  <div className="mt-4 text-center">
                    <p>Don't have an account? <Link to="/register" className="fw-medium text-primary"> Register </Link></p>
                    <p>© 2025 Namaste World Tour.</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

const mapStatetoProps = state => {
  const { loginError } = state.Login;
  return { loginError };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError })(Login));
